import React from 'react';

interface FileIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const FileIcon: React.FC<FileIconProps> = ({ 
  width = 21, 
  height = 20, 
  color = "white" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 21 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M13.4166 2.5L17.1666 6.01852M13.4166 2.5V6.01852H17.1666M13.4166 2.5H4.66663V16.6667H11.3333M17.1666 6.01852V10.9259M17.1966 14.1333V19.1916M14.6666 16.6634H19.725" 
        stroke={color} 
        strokeWidth="1.3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileIcon;

